import { Particular } from '@/types/entity';

/**
 * @author <Aniket.P>
 * @description Math utils
 * @copyright Supra International, inc
 */
export class MathUtils {

    public static formatCurrency(amountInCent: number): string {
        const amount = Math.round(amountInCent / 100);
        const formattedAmount = amount.toString().includes('.') ? '$' + amount.toString() : '$' + amount.toString() + '.00';
        return formattedAmount;
    }

    public static formatCurrencyWithoutRound(amountInCent: number): string {
        const amount = (amountInCent / 100).toFixed(2);
        const formattedAmount = amount.toString().includes('.') ? '$' + amount.toString() : '$' + amount.toString() + '.00';
        return formattedAmount;
    }

    public static convertMiles(distanceInMiles: number) {
        if (distanceInMiles) {
            return Math.round((distanceInMiles + Number.EPSILON) * 100) / 100;
        } else {
            return 0;
        }
    }

    public static calculateTotal(particulars: Particular[]): number {
        let totalAmount = 0;
        if (particulars) {
            particulars.forEach((element) => {
                totalAmount += element.amount;
            });
        }
        return totalAmount;
    }

    public static convertDollarToCents(dollarString: string): number {
        const normalized = dollarString.replace(/\$|,/g, '');
        const cents = Math.round(parseFloat(normalized) * 100);
        return cents;
    }
}
